(() => {
  if (window.lbbMobileControlsReady) return;
  window.lbbMobileControlsReady = true;
  const mobile = matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const styles = new Map();
  const shadowObservers = new Map();
  const sizeTargets = new Set();
  let frame;
  let discovery;
  const visible = (el) => !!el
    && !el.closest('[hidden], [inert], [aria-hidden="true"], details:not([open])')
    && !!el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  const toggle = (name, value) => {
    if (root.classList.contains(name) !== value) root.classList.toggle(name, value);
  };
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; sync(); });
  };
  const sizeObserver = new ResizeObserver(schedule);
  const observeSizes = (elements) => {
    const next = new Set(elements.filter(Boolean));
    sizeTargets.forEach((element) => {
      if (!next.has(element)) { sizeObserver.unobserve(element); sizeTargets.delete(element); }
    });
    next.forEach((element) => {
      if (!sizeTargets.has(element)) { sizeTargets.add(element); sizeObserver.observe(element); }
    });
  };
  const observeShadow = (shadow) => {
    if (!shadow || shadowObservers.has(shadow)) return;
    const observer = new MutationObserver((records) => {
      const ownStyle = styles.get(shadow);
      if (records.some((record) => record.target !== ownStyle && record.target.parentNode !== ownStyle)) schedule();
    });
    observer.observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-expanded', 'open', 'aria-hidden'] });
    shadowObservers.set(shadow, observer);
  };
  const shadowStyle = (shadow, css) => {
    if (!shadow) return;
    let style = styles.get(shadow);
    if (!style || style.parentNode !== shadow) {
      style = document.createElement('style');
      style.id = 'lbb-mobile-controls';
      shadow.append(style);
      styles.set(shadow, style);
    }
    if (style.textContent !== css) style.textContent = css;
  };
  const sync = () => {
    if (!mobile.matches) {
      styles.forEach((style) => style.remove());
      styles.clear();
      shadowObservers.forEach((observer) => observer.disconnect());
      shadowObservers.clear();
      observeSizes([]);
      toggle('lbb-mobile-controls-busy', false);
      toggle('lbb-mobile-promo-quiet', false);
      toggle('lbb-mobile-chat-open', false);
      root.style.removeProperty('--lbb-mobile-controls-bottom');
      return;
    }
    shadowObservers.forEach((observer, shadow) => {
      if (!shadow.host.isConnected) {
        observer.disconnect();
        shadowObservers.delete(shadow);
        styles.get(shadow)?.remove();
        styles.delete(shadow);
      }
    });
    const kit = document.getElementById('bundlesuiteContainer');
    const cart = kit?.querySelector('.side-cart-container');
    const checkoutBar = document.querySelector('.lbb-cart-summary:not(.is-empty) .lbb-cart-mobile-bar');
    observeSizes([cart, checkoutBar, document.querySelector('lbb-mobile-buy-bar')]);
    const cartFixed = visible(cart) && getComputedStyle(cart).position === 'fixed';
    const expanded = !!cart?.querySelector('.lbb-lissage-kit-toggle[aria-expanded="true"], .lbb-kit-mobile-toggle[aria-expanded="true"], .lbb-hair-kit-toggle[aria-expanded="true"], .lbb-body-kit-toggle[aria-expanded="true"]') || !!cart?.classList.contains('lbb-kit-mobile-open');
    const overlay = [...document.querySelectorAll('dialog[open], modal-dialog[open], product-modal[open], quick-add-modal[open], cart-drawer.active, cart-notification.active, header-drawer details[open], .mobile-facets__disclosure[open], [role="dialog"][aria-modal="true"]')].some(visible);
    const keyboard = !!document.activeElement?.matches('textarea, [contenteditable="true"], input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"])');
    const busy = overlay || keyboard || (cartFixed && expanded);
    const buyHeight = root.classList.contains('lbb-mobile-purchase-visible') ? parseFloat(getComputedStyle(root).getPropertyValue('--lbb-mobile-purchase-height')) || 82 : 0;
    const bottom = Math.ceil(Math.max(buyHeight, cartFixed ? cart.getBoundingClientRect().height : 0)) + 12;
    const checkoutBarFixed = visible(checkoutBar) && getComputedStyle(checkoutBar).position === 'fixed';
    let chatBottom = Math.max(bottom, checkoutBarFixed ? Math.ceil(checkoutBar.getBoundingClientRect().height) + 12 : 0);
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    const inlineCheckout = checkoutBarFixed ? document.querySelector('.lbb-cart-summary:not(.is-empty) #checkout.cart__checkout-button') : null;
    if (visible(inlineCheckout)) {
      const checkoutRect = inlineCheckout.getBoundingClientRect();
      const launcherRect = (runtime || chatRoot)?.querySelector('.activator-nudge')?.getBoundingClientRect();
      const chatRight = launcherRect?.right || window.innerWidth - 12;
      const projectedBottom = window.innerHeight - chatBottom;
      const overlapX = chatRight > checkoutRect.left && chatRight - 44 < checkoutRect.right;
      const overlapY = projectedBottom + 12 > checkoutRect.top && projectedBottom - 44 < checkoutRect.bottom + 12;
      if (checkoutRect.bottom > 0 && checkoutRect.top < window.innerHeight && overlapX && overlapY) {
        chatBottom = Math.max(chatBottom, Math.ceil(window.innerHeight - checkoutRect.top) + 12);
      }
    }
    const chatOpen = (runtime || chatRoot)?.querySelector('.activator[aria-expanded="true"]');
    toggle('lbb-mobile-chat-open', !!chatOpen);
    const hideLauncher = busy && !chatOpen;
    const css = '@media(max-width:749px){.activator-nudge.activator-nudge{' + (hideLauncher ? 'display:none!important;' : '') + 'bottom:' + chatBottom + 'px!important;right:12px!important;width:44px!important;max-width:44px!important;min-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{box-sizing:border-box!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;border-radius:50%!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:0!important}.activator-nudge .activator__label{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}}';
    shadowStyle(chatRoot, css);
    shadowStyle(runtime, css);
    observeShadow(chatRoot);
    observeShadow(runtime);
    shadowStyle(document.querySelector('pandectes-cmp')?.shadowRoot, '@media(max-width:749px){button.widget.bottom.left{' + (busy ? 'display:none!important;' : '') + 'bottom:' + bottom + 'px!important}}');
    toggle('lbb-mobile-controls-busy', busy);
    toggle('lbb-mobile-promo-quiet', busy || !!kit || !!document.querySelector('main product-info, #product-grid') || buyHeight > 0);
    if (root.style.getPropertyValue('--lbb-mobile-controls-bottom') !== bottom + 'px') root.style.setProperty('--lbb-mobile-controls-bottom', bottom + 'px');
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden', 'aria-expanded', 'aria-modal'] });
  new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['class'] });
  ['scroll', 'resize'].forEach((event) => window.addEventListener(event, schedule, { passive: true }));
  ['click', 'toggle', 'focusin', 'focusout', 'change'].forEach((event) => document.addEventListener(event, schedule, true));
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  let attempts = 0;
  discovery = setInterval(() => { schedule(); if (++attempts >= 60) clearInterval(discovery); }, 1000);
  sync();
})();
